/**
 * Removes all HTML tags from a string and collapses leftover whitespace into single spaces.
 * Used to sanitize fields like vehicle.notes before sending the save payload through CloudFront,
 * which blocks requests containing HTML via the SizeRestrictions_Body WAF rule.
 */
export const stripHtmlTags = (value: string): string => {
    return value
        .replace(/<[^>]*>/g, '')
        .replace(/\s+/g, ' ')
        .trim();
};

export type StringPart = string | number | null | undefined;

export const normalizeStringPart = (part: StringPart): string => {
    const stringPart = String(part ?? '').trim();

    return stringPart.toLowerCase() === 'undefined' ? '' : stringPart;
};

export const joinNonEmptyStringParts = (...parts: StringPart[]): string => parts.map(normalizeStringPart).filter(Boolean).join(' ');
